export default __webpack_public_path__ + "static/media/4_Rooms.380d05d9.png";